import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { FormattedMessage } from 'react-intl';

export const getFormFields = (messages, intl, confirmLabel, description) => [
  {
    variant: 'custom',
    component: <Typography variant="bodyMedium">{description}</Typography>,
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'text',
    name: 'wassId',
    InputLabelProps: {
      TooltipProps: {
        title: intl.formatMessage(messages.wassIdTooltip),
        children: <AlertInfoIcon fontSize="small" />,
      },
    },
    label: <FormattedMessage {...messages.wassIdLabel} />,
    placeholder: intl.formatMessage(messages.wassIdPlaceholder),
    rules: {
      required: true,
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'text',
    name: 'password',
    label: <FormattedMessage {...messages.passwordLabel} />,
    placeholder: intl.formatMessage(messages.passwordPlaceholder),
    type: 'password',
    rules: {
      required: true,
    },
    GridProps: {
      xs: 12,
    },
  },
  {
    variant: 'checkbox',
    name: 'confirm',
    'aria-label': confirmLabel,
    label: confirmLabel,
    GridProps: {
      xs: 12,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
    },
  },
];
